require("./lib/pym");
require("./analytics");

var $ = require("./lib/qsa");


// open an annotation from an anchor link
var activate = function(e) {
  e.preventDefault();
  e.stopPropagation();
  $(`[aria-expanded="true"]`).filter(t => t != this).forEach(a => a.setAttribute("aria-expanded", "false"));
  var active = this.getAttribute("aria-expanded") != "true";
  this.setAttribute("aria-expanded", active);
  if (active) {
    var comment = this.nextElementSibling;
    comment.focus();
  }
}

// close an annotation from the document or "return to text"
var clear = function(e) {
  e.preventDefault();
  e.stopPropagation();
  var current = $.one(`[aria-expanded="true"]`)
  if (!current) return;
  current.setAttribute("aria-expanded", "false");
  current.focus();
};

// allow links to fire inside of the asides by halting clicks before they hit the body
var link = function(e) {
  e.stopPropagation();
};

// get all spans and move the quotes up to their respective paragraphs
var anchors = $(".comment-anchor");
anchors.forEach(function(anchor) {
  var paragraph = anchor.closest("p");
  var comment = $.one(anchor.getAttribute("href"));
  var clone = comment.cloneNode(true);
  // comment.parentElement.removeChild(comment);
  clone.classList.add("inline");
  var parent = anchor.parentElement;
  // weird swap because insertAfter() doesn't exist
  parent.insertBefore(clone, anchor);
  parent.insertBefore(anchor, clone);
  anchor.addEventListener("click", activate);
  anchor.setAttribute("aria-expanded", "false");
  anchor.setAttribute("aria-controls", clone.id);

  var close = clone.querySelector(".return");
  close.addEventListener("click", clear);

  clone.addEventListener("click", link);
});

document.body.addEventListener("click", clear);
document.body.addEventListener("keyup", function(e) {
  if (e.keyCode == 27) clear(e);
})